module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 55.4 27.6"><path class="st0" d="M31.9 10.5l-16.5 4.3c-3.4.9-6.1.8-7.6-.4-3.9-2.8-.9-8.6.2-10.3-2 2.1-3.9 4.2-5.4 6.5C.2 14.3-.8 18.2.8 20.7c2.9 4.6 9.7 2.5 14.1.7l40.5-17L38 9"/></svg>'};


//////////////////
// WEBPACK FOOTER
// ./src/assets/swoosh.svg
// module id = 119
// module chunks = 1